import { QueryConfig } from "store/utils/query-config";

export const profitAllocationRecordsDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["allocatedAt"],
  },
};

export function profitAllocationRecordsQueryForBooking(
  bookingId: string
): QueryConfig {
  return {
    query: { bookingId },
    options: { sortBy: ["allocatedAt"] },
  };
}
